module.exports = __webpack_public_path__ + "img/stamp-frozen.12946864.png";